<template>
  <div>
    <div v-if="viewTye === 'LIST'">
      <el-row>
        <el-col :span="3">
          <span class="dash-value dash-num-blue" style="margin-top: 16px">{{
            totalCount
          }}</span
          >&nbsp; <span class="dash-title">{{this.$t('monitor.unit')}}</span>&nbsp;
        </el-col>
        <el-col :span="21">
          <SearchCriterial
            :handleReset="handleReset"
            :searchParams="searchParams"
            :handleChangeSearchParams="handleChangeSearchParams"
            :handleSearch="handleSearch"
          />
        </el-col>
      </el-row>

      <el-table :data="items" style="padding: 10px 10px 10px 10px;">
        <el-table-column prop="input" :label="this.$t('monitor.input')"  width="300" >
          <template slot-scope="scope">
            <el-tooltip placement="top">
              <div slot="content">{{ scope.row.input }}</div>
              <div class="dash-num-blue">
                {{ scope.row.input | cutString(25) }}
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="robotName" :label="this.$t('monitor.robotName')" >
        </el-table-column>
        <el-table-column prop="functionName" :label="this.$t('monitor.functionName')"> </el-table-column>
        <el-table-column prop="date" :label="this.$t('monitor.date')">
        </el-table-column>
        <el-table-column prop="start" :label="this.$t('monitor.start')" >
        </el-table-column>
        <el-table-column prop="end" :label="this.$t('monitor.end')"> </el-table-column>
        <el-table-column :label="this.$t('monitor.result')">
          <template slot-scope="scope">
            <el-tag
              size="small"
              type="success"
              v-if="scope.row.result.startsWith('成功')"
              >{{ scope.row.result }}</el-tag
            >
            <el-tag size="small" type="danger" v-else>{{
              scope.row.result
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('monitor.note')">
          <template slot-scope="scope">
            <el-tooltip placement="top">
              <div slot="content">{{ scope.row.note }}</div>
              <div class="dash-num-blue">
                {{ scope.row.note | cutString(6) }}
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('monitor.process')"  width="80">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              @click="retry(scope.row)"
              v-if="scope.row.functionID === 2"
              >{{$t('monitor.redo')}}</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <PageBar>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="totalCount"
          @current-change="handleCurrentChange"
          :current-page.sync="searchParams.pageIndex"
          :page-size="searchParams.pageSize"
        >
        </el-pagination>
      </PageBar>
    </div>
    
  </div>
</template>

<script>
import SearchCriterial from "@/components/robot/monitor/SearchCriterial.vue";
import PageBar from "@/components/common/PageBar.vue";
import { monitor,retry } from "@/api/robot";
import { mapState } from "vuex";
const defaultSearchParams = {
  searchType: "",
  functioniID: "",
  result: "",
  pageIndex: 1,
  pageSize: 10,
};
const VIEW_TYPE = {
  LIST: "LIST",
  REVIEW: "REVIEW",
};
export default {
  name: "Monitor",
  components: { SearchCriterial, PageBar },
  data: () => {
    return {
      viewTye: VIEW_TYPE.LIST,
      currentData: null,
      searchParams: { ...defaultSearchParams },
      totalCount: 0,
      items: [],
    };
  },
  mounted() {
    this.refreshData();
  },
  computed: {
    ...mapState(["accountInfo"]),
  },
  methods: {
    refreshData() {
      monitor({
        userID: this.accountInfo.userID,
        ...this.searchParams,
      }).then((response) => {
        this.totalCount = response.data.totalCount;
        this.items = response.data.items;
      });
    },
    handleCurrentChange(val) {
      this.searchParams = { ...this.searchParams, pageIndex: val };
      this.refreshData();
    },
    handleChangeSearchParams(searchParams) {
      this.searchParams = searchParams;
    },
    handleSearch() {
      this.searchParams = { ...this.searchParams, pageIndex: 1 };
      this.refreshData();
    },
    handleReset() {
      this.searchParams = { ...defaultSearchParams };
      this.refreshData();
    },
    review(rowData) {
      this.currentData = rowData;
      this.viewTye = VIEW_TYPE.REVIEW;
    },
    handleGoBackToList() {
      this.currentData = null;
      this.viewTye = VIEW_TYPE.LIST;
    },
    retry(rowData) {
      var fn = rowData.input;
      retry({
        filename: fn
      }).then((response) => {
        if (response.code == "000") {
          this.refreshData();
        } 
        
      });
    }
  },
};
</script>
